export default "__VITE_ASSET__CLC3WOsF__"